import React from 'react';

import { useField } from 'formik';
import { at } from 'lodash';

import { TextField } from '@material-ui/core';

export default function InputField(props) {
  const { ...rest } = props;
  const [field, meta] = useField(props);
  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
  }

  return (
    <TextField
      type='text'
      variant='outlined'
      size='small'
      error={meta.touched && meta.error && true}
      helperText={_renderHelperText()}
      {...field}
      {...rest}
    />
  );
}
